import { EventEmitter, Output } from '@angular/core';
import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IAgent, IAgentForSettingsView, IMachineFromApi } from 'app/models';

import { AgentService } from 'app/services';
import { MessageService } from 'app/services/message/message.service';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent, ConfirmDialogModel } from '../confirm-dialog/confirm-dialog.component';



@Component({
  selector: 'app-agent-mngt-detail',
  templateUrl: './agent-mngt-detail.component.html',
  styleUrls: ['./agent-mngt-detail.component.scss'],
})
export class AgentMngtDetailComponent implements OnInit {
  @Input()
  machines: IMachineFromApi[] = [];
  @Input()
  agentsData: IAgentForSettingsView[] = [];

  @Output()
  agentSaved = new EventEmitter<boolean>();

  agentForm!: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    private agentService: AgentService,
    private messageService: MessageService,
    private dialog: MatDialog,
  ) { }

  ngOnInit(): void {
    this.initEmpty();
  }

  initEmpty() {
    this.agentForm = this.formBuilder.group(
      {
        id: undefined,
        machineId: [null, Validators.required],
        enabled: [false, Validators.required],
      },
      {}
    );
  }

  initEdit(currentAgent: IAgent) {
    this.agentForm.setValue({
      id: currentAgent.id,
      machineId: currentAgent.machineId,
      enabled: currentAgent.enabled,
    });
  }

  clear(): void {
    this.agentForm.reset();
  }

  saveConfirmDialog(): void {
    const message = `The selected machine already has an agent`;
    const dialogData = new ConfirmDialogModel('Confirm save action Anyway', message);

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: dialogData,
    });

    dialogRef.afterClosed().subscribe((dialogResult) => {
      if (dialogResult) {
        this.saveOrUpdate();
      }
    });
  }

  onSubmit() {
    if (!this.agentForm) {
      return;
    }
    if (this.agentForm.invalid) {
      return;
    }
    if (this.agentService.existsAgentByMachineId(this.agentsData, this.agentForm.value.machineId, this.agentForm.value.id)) {
      this.saveConfirmDialog();
    } else {
      this.saveOrUpdate();
    }
  }

  saveOrUpdate() {
    if (this.agentForm.value.id) {
      this.agentService.updateIAgent(this.agentForm.getRawValue()).subscribe(
        (): void => {
          this.agentSaved.emit(true);
          this.clear();
        },
        () => this.messageService.showDirectSimpleMessage(` Agent save Error`)
      );
      return;
    }
    this.agentService
      .addIAgentGenerateUsername(this.agentForm.getRawValue())
      .subscribe(
        (): void => {
          this.agentSaved.emit(true);
          this.clear();
        },
        () => this.messageService.showDirectSimpleMessage(` Agent save Error`)
      );
  }
}
